import stickybits from 'stickybits'

( function( $ ) {

    var headerHeight = $('.topbar').height();

    stickybits('.topbar-simple', {
        stickyBitStickyOffset: 0,
        useStickyClasses: true
    });

    stickybits('.sidebar-v2', {
        stickyBitStickyOffset: headerHeight + 30,
        useStickyClasses: true
    });

    stickybits('.col-sidebar', {
        stickyBitStickyOffset: 90,
        useStickyClasses: true
    });

})(jQuery);